import * as React from 'react'

import { ItemCountup } from '@thg-commerce/enterprise-widget-itemcountup'

export interface TopNItem {
  title: string
  description: string
  image: string
  link?: string
}
export interface TopNItemRendererProps {
  isAmp: boolean
  items: TopNItem[]
}

export const TopNItemRenderer = (props: TopNItemRendererProps) => {
  const itemCountupItems = props.items.map((item: TopNItem) => ({
    title: item.title,
    content: item.description,
    images: [
      {
        src: item.image,
        alt: '',
      },
    ],
  }))

  return <ItemCountup items={itemCountupItems} isAmp={props.isAmp} />
}
